import React, { useMemo } from "react";
import { buildNodeTree } from "./../../ricos-viewer-next/ContentViewer/utils/node-tree-traversal.js";
const NodeTreeMapContext = React.createContext(null);
const NodeTreeMapContextProvider = ({ nodes, children }) => {
  const nodeTreeMap = useMemo(() => {
    const { map } = buildNodeTree(nodes);
    return map;
  }, [nodes]);
  return /* @__PURE__ */ React.createElement(NodeTreeMapContext.Provider, { value: { nodeTreeMap } }, children);
};
export {
  NodeTreeMapContext,
  NodeTreeMapContextProvider
};
//# sourceMappingURL=node-tree-map-context.js.map
